// src/services/workspacesService.js
import { apiClient } from "./apiClient";

export const workspacesService = {
  // --- WORKSPACES ---

  async getAll(token) {
    // Expected response: { object: "list", data: [...] }
    return apiClient("/workspaces", {
      token,
      method: "GET",
    });
  },

  async create(token, name, type = "home") {
    // Tests use { name, type }. Description is optional.
    return apiClient("/workspaces", {
      token,
      method: "POST",
      body: { name, type },
    });
  },

  async update(token, workspaceId, data) {
    return apiClient(`/workspaces/${workspaceId}`, {
      token,
      method: "PUT",
      body: data, // e.g., { name: "New Name" }
    });
  },

  async delete(token, workspaceId) {
    return apiClient(`/workspaces/${workspaceId}`, {
      token,
      method: "DELETE",
    });
  },

  // --- MEMBERS ---

  async getMembers(token, workspaceId) {
    return apiClient(`/workspaces/${workspaceId}/members`, {
      token,
      method: "GET",
    });
  },

  /**
   * For Real: { userId, role, displayName, color, avatarUrl }
   * For Artificial: { displayName, color, avatarUrl, isArtificial: true }
   */
  async addMember(token, workspaceId, memberData) {
    return apiClient(`/workspaces/${workspaceId}/members`, {
      token,
      method: "POST",
      body: memberData,
    });
  },

  async updateMember(token, workspaceId, profileId, data) {
    return apiClient(`/workspaces/${workspaceId}/members/${profileId}`, {
      token,
      method: "PUT",
      body: data,
    });
  },

  async removeMember(token, workspaceId, profileId) {
    return apiClient(`/workspaces/${workspaceId}/members/${profileId}`, {
      token,
      method: "DELETE",
    });
  },

  // --- INVITES ---

  async createInvite(token, workspaceId, email, role = "member") {
    return apiClient(`/workspaces/${workspaceId}/invites`, {
      token,
      method: "POST",
      body: { email, role },
    });
  },

  async deleteInvite(token, workspaceId, inviteId) {
    return apiClient(`/workspaces/${workspaceId}/invites/${inviteId}`, {
      token,
      method: "DELETE",
    });
  },

  async getInvites(token, workspaceId) {
    return apiClient(`/workspaces/${workspaceId}/invites`, {
      token,
      method: "GET",
    });
  },

  async getMyInvites(token) {
    return apiClient(`/workspaces/invitations/me`, {
      token,
      method: "GET",
    });
  },

  async acceptInvite(token, inviteToken, displayName) {
    return apiClient(`/workspaces/accept-invite`, {
      token,
      method: "POST",
      body: { token: inviteToken, displayName },
    });
  },

  // --- FEATURES ---

  async getFeatures(token, workspaceId) {
    return apiClient(`/workspaces/${workspaceId}/features`, {
      token,
      method: "GET",
    });
  },

  async setFeature(token, workspaceId, featureId, enabled = true) {
    return apiClient(`/workspaces/${workspaceId}/features`, {
      token,
      method: "POST",
      body: { featureId, enabled },
    });
  },

  async removeFeature(token, workspaceId, featureId) {
    return apiClient(`/workspaces/${workspaceId}/features/${featureId}`, {
      token,
      method: "DELETE",
    });
  },
};